import { ConfigurationModel, ContactDetails, DeliveryMethodModel, RetailerDeliveryLocationModel, RetailerDocumentModel, RetailerOnboardingDataModel } from '../../../../app/services/api/ofdClient';

export const isCompanyDetailsValid = (result: RetailerOnboardingDataModel ) => {
  return !!(
    result.name &&
    result.addressLine1 &&
    result.postalCode &&
    result.city &&
    result.country &&
    result.region &&
    result.vatnumber &&
    result.awrsnumber &&
    result.directors &&
    result.eorinumber &&
    result.franchiseName
  );
};
  
export const isContactDetailsValid = (result: ContactDetails ) => {
  return !!(
    result.name &&
    result.jobTitle &&
    result.email &&
    result.phoneNumber &&
    result.interestReason &&
    result.rangeRequirements &&
    result.serviceNeeds
  );
};

export const isDueDiligenceValid = (result: RetailerDocumentModel[]) => {
  return result.filter(x => x.fieldRequired).every(doc => doc.approved === true);
};


export const isDeliveryLocationsValid = (result: RetailerDeliveryLocationModel[] ) => {
  return !!(
    result.length > 0
  );
};

export const isConfigurationValid = (result: ConfigurationModel, deliveryMethods?: DeliveryMethodModel[]) => {
  return !!(
    result.storeId &&
    result.externalIdentifier &&
    result.containerSizeId &&
    result.catalogues && result.catalogues.length > 0 &&
    result.minContainerFillPercentage &&
    result.palletSizeId &&
    deliveryMethods?.some(m => m.enabled === true)
  );
};
